import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-67">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1511895426328-dc8714191300?w=1920&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-68">
        <div className="absolute inset-0 bg-black/50" data-id="element-69" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 md:px-12 text-center text-white max-w-4xl" data-id="element-70">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6" data-id="element-71">
          ¿Qué le pasa a tu familia si mañana tú no puedes trabajar?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl lg:text-2xl font-light mb-10 text-gray-200" data-id="element-72">
          Descubre el programa que protege a los tuyos mientras construyes tu
          futuro financiero.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-73">
          <a href="#reserva" className="inline-block bg-magi-navy hover:bg-magi-navyHover text-white px-8 py-4 rounded-full text-lg md:text-xl font-medium transition-all duration-300 transform hover:scale-105 shadow-lg" data-id="element-74">
            Reserva una sesión privada para proteger a tu familia
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10" data-id="element-75">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-76">
          <ChevronDown className="text-white/70 w-8 h-8" data-id="element-77" />
        </motion.div>
      </motion.div>
    </section>;
}